import $ from 'jquery'


/* var session = $('meta[name="session-cookie"').attr("content")

if(session == "") {
    UIkit.modal("#login-modal").show();
} */

var overlay = document.getElementById("overlay")

window.addEventListener('load', function () {
    overlay.style.display = "none"
})

const hamburger = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobileMenu');
hamburger.addEventListener('click', () => {
    const open = hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
});
mobileMenu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
    });
});